// export const admin_sidenav = {
//     items:[
//       {
//           group:'Admed',
//           status:false,
//           id:[1.2,2.2],
//           item:[
//               {
//                   label: 'Admin',
//                   disabled: false,
//                   action: 'admin',
//                   show: true,
//                   status:true,
//                   link: 'admin',
//                   icon: 'fa-home',
//                   slag:'1',
//                   uniqueId:'1.2'
//               },
//               {
//                 label: 'Dashboard',
//                 disabled: false,
//                 action: 'dashboard',
//                 show: true,
//                 status:true,
//                 link: 'dashboard',
//                 icon: 'fa-dashboard',
//                 slag:'2',
//                 uniqueId:'2.2'
//               },
//           ]
//       },
//       {
//           group: 'TEMPLATES',
//           status:false,
//           id:['3.2','4.2'],
//           item:[
//             {
//               label: 'Current',
//               disabled: false,
//               action: 'view_current_secondary',
//               show: true,
//               status:true,
//               link: 'current-templates',
//               icon: 'fa-file-text',
//               slag:'3',
//               uniqueId:'3.2'
//             },
//             {
//               label: 'All',
//               disabled: false,
//               action: 'view-templates',
//               show: true,
//               status:true,
//               link: 'templates',
//               icon: 'fa-file-text',  
//               slag:'4',
//               uniqueId:'4.2'
//             }
//           ]
//       },
//       {
//         group: 'APPLICATIONS',
//         status:false,
//         id:[5.2,6.2],
//         item:[
//           {
//             label: 'Submitted',
//             action: 'view-applications',
//             disabled: false,
//             show: true,
//             status:true,
//             link: 'applications',
//             icon: 'fa-file-text',
//             slag:'5',
//             uniqueId:'5.2'
//           },
//           {
//             label: 'Documents',
//             action: 'view-documents',
//             disabled: false,
//             show: true,
//             status:true,
//             link: 'documents',
//             icon: 'fa-files-o',
//             slag:'6',
//             uniqueId:'6.2'
//           },
//         ]
//       },
//       {
//         group: 'AMENDMENTS',
//         status:false,
//         id:[7.2,8.2],
//         item:[
//           {
//             label: 'Amendments',
//             disabled: false,
//             action: 'amendments',
//             show: true,
//             status:true,
//             link: 'amendments',
//             icon: 'fa-files-o',
//             slag:'7',
//             uniqueId:'7.2'
//           },
//           {
//             label: 'Documents',
//             action: 'view-amendment-documents',
//             disabled: false,
//             show: true,
//             status:true,
//             link: 'amendment-documents',
//             icon: 'fa-files-o',
//             slag:'8',
//             uniqueId:'8.2'
//           },
//         ]
//       },
//       {
//         group: 'CLAIMS',
//         status:false,
//         id:[9.2,10.2,11.2],
//         item:[
//           {
//             label: 'Claims',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'view_claims',
//             link: 'claims',
//             icon: 'fa-files-o',
//             slag:'9',
//             uniqueId:'9.2'
//           },
//           {
//             label: 'Documents',
//             action: 'view_claims_documents',
//             disabled: false,
//             show: true,
//             status:true,
//             link: 'claim-documents',
//             icon: 'fa-files-o',
//             slag:'10',
//             uniqueId:'10.2'
//           },
//           {
//             label: 'Outstanding',
//             action: 'view_outstanding_documents',
//             disabled: false,
//             show: true,
//             status:true,
//             link: 'outstanding-documents',
//             icon: 'fa-files-o',
//             slag:'11',
//             uniqueId:'11.2'
//           },
//         ]
//       },
//       {
//         group: 'FEEDBACK',
//         status:false,
//         id:[12.2],
//         item:[
//           {
//             label: 'Complaints',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'view_complaints',
//             link: 'complaints',
//             icon: 'fa-comments',
//             slag:'12',
//             uniqueId:'12.2'
//           },
//         ]
//       },
//       {
//         group:'Settings',
//         status:false,
//         id:[13.2,14.2,15.2,16.2,17.2],
//         item:[
//           {
//             label: 'Users',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'settings/users',
//             link: 'settings/users',
//             icon: 'fa-comments',
//             slag:'13',
//             uniqueId:'13.2'
//           },
//           {
//             label: 'Privileges',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'settings/privileges',
//             link: 'settings/privileges',
//             icon: 'fa-comments',
//             slag:'14',
//             uniqueId:'14.2'

//           },
//           {
//             label: 'Roles',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'settings/roles',
//             link: 'settings/roles',
//             icon: 'fa-comments',
//             slag:'15',
//             uniqueId:'15.2'
//           },
//           {
//             label: 'General Setting1',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'settings/general-settings',
//             link: 'settings/general-settings',
//             icon: 'fa-comments',
//             slag:'16',
//             uniqueId:'16.2'
//           },
//           {
//             label: 'Applications1',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'settings/applications',
//             link: 'settings/applications',
//             icon: 'fa-comments',
//             slag:'17',
//             uniqueId:'17.2'
//           },
//           {
//             label: 'Amendments',
//             disabled: false,
//             show: true,
//             status:true,
//             action: 'settings/amendments',
//             link: 'settings/amendments',
//             icon: 'fa-comments',
//             slag:'18',
//             uniqueId:'18.2'
//           },
//         ]
//       }
//   ]
// }

export const admin_menu = [
    {
      label:'Admed',
      icon:'list_alt',
      type:'primary',
      disabled:false,
      slag:'99',
      uniqueId:[1.2,2.2],
      item:[
        {
          label: 'Admin',
          type:'secondary',
          disabled: false,
          link: 'admin',
          icon: 'apple',
          slag:'1',
          uniqueId:'1.2'
        },
        {
          label: 'Dashboard',
          type:'secondary',
          disabled: false,
          link: 'dashboard',
          icon: 'dashboard',
          slag:'2',
          uniqueId:'2.2'
        },
      ]
    },
    {
      label:'Template',
      icon:'explore',
      type:'primary',
      disabled:false,
      slag:'99',
      uniqueId:['3.2','4.2'],
      item:[
        {
          label: 'Current',
          type:'secondary',
          disabled: false,
          link: 'current-templates',
          icon: 'stay_current_landscape',
          slag:'3',
          uniqueId:'3.2'
        },
        {
          label: 'All',
          type:'secondary',
          disabled: false,
          link: 'templates',
          icon: 'hourglass_full',  
          slag:'4',
          uniqueId:'4.2'
        },
      ]
    },
    {
      label:'APPLICATIONS',
      icon:'table',
      type:'primary',
      disabled:false,
      slag:'99',
      uniqueId:['5.2','6.2'],
      item:[
        {
          label: 'Submitted',
          type:'secondary',
          action: 'view-applications',
          link: 'applications',
          icon: 'store',
          slag:'5',
          uniqueId:'5.2'
        },
        {
          label: 'Documents',
          type:'secondary',
          action: 'view-documents',
          link: 'documents',
          icon: 'file_copy',
          slag:'6',
          uniqueId:'6.2'
        },
      ]
    },
    {
      label:'AMENDMENTS',
      icon:'help',
      type:'primary',
      disabled:false,
      slag:'99',
      uniqueId:['7.2','8.2'],
      item:[
        {
          label: 'Amendments',
          type:'secondary',
          disabled: false,
          link: 'amendments',
          icon: 'perm_media',
          slag:'7',
          uniqueId:'7.2'
        },
        {
          label: 'Documents',
          type:'secondary',
          disabled: false,
          link: 'amendment-documents',
          icon: 'file_copy',
          slag:'8',
          uniqueId:'8.2'
        },
      ]
    },
    {
      label:'CLAIMS',
      icon:'card_membership',
      type:'primary',
      disabled:false,
      slag:'99',
      uniqueId:['9.2','10.2','11.2'],
      item:[
        {
          label: 'Claims',
          type:'secondary',
          disabled: false,
          link: 'claims',
          icon: 'redeem',
          slag:'9',
          uniqueId:'9.2'
        },
        {
          label: 'Documents',
          type:'secondary',
          disabled: false,
          link: 'claim-documents',
          icon: 'file_copy',
          slag:'10',
          uniqueId:'10.2'
        },
        {
          label: 'Outstanding',
          type:'secondary',
          disabled: false,
          link: 'outstanding-documents',
          icon: 'reorder',
          slag:'11',
          uniqueId:'11.2'
        },
      ]
    },
    {
      label:'FEEDBACK',
      icon:'feedback',
      type:'primary',
      disabled:false,
      slag:'99',
      uniqueId:['12.2'],
      item:[
        {
          label: 'Complaints',
          type:'secondary',
          disabled: false,
          link: 'complaints',
          icon: 'question_answer',
          slag:'12',
          uniqueId:'12.2'
        },
      ]
    },
    {
      label:'SETTINGS',
      icon:'settings_applications',
      type:'primary',
      disabled:false,
      slag:'99',
      uniqueId:['13.2','14.2','15.2','16.2','17.2'],
      item:[
        {
          label: 'Users',
          type:'secondary',
          disabled: false,
          link: 'settings/users',
          icon: 'supervised_user_circle',
          slag:'13',
          uniqueId:'13.2'
        },
        {
          label: 'Privileges',
          type:'secondary',
          disabled: false,
          link: 'settings/privileges',
          icon: 'nature_people',
          slag:'14',
          uniqueId:'14.2'
    
        },
        {
          label: 'Roles',
          type:'secondary',
          disabled: false,
          link: 'settings/roles',
          icon: 'stars',
          slag:'15',
          uniqueId:'15.2'
        },
        {
          label: 'General Setting',
          type:'secondary',
          disabled: false,
          link: 'settings/general-settings',
          icon: 'settings_applications',
          slag:'16',
          uniqueId:'16.2'
        },
        {
          label: 'Applications',
          type:'secondary',
          disabled: false,
          link: 'settings/applications',
          icon: 'fingerprint',
          slag:'17',
          uniqueId:'17.2'
        },
        {
          label: 'Amendments',
          type:'secondary',
          disabled: false,
          link: 'settings/amendments',
          icon: 'fingerprint',
          slag:'18',
          uniqueId:'18.2'
        },
      ]
    }
]

